var module = angular.module('octopusApp.certificates');

module.controller('CertificateNewController', function ($scope, busy, octopusRepository, $state, unsavedChanges, $q) {
    var isLoading = $scope.isLoading = busy.create();
    var isSaving = $scope.isSaving = busy.create();
    
    $scope.certificate = { TenantedDeploymentParticipation: 'Untenanted' };
    $scope.availableTenants = [];

    isLoading.promise(octopusRepository.Environments.all().then(function(environments){
        $scope.environments = environments;
    }));

    isLoading.promise(octopusRepository.Tenants
        ? octopusRepository.Tenants.all().then(function(tenants){ $scope.availableTenants = tenants; })
        : $q.resolve([]));
    
    $scope.save = function(){
       isSaving.promise(octopusRepository.Certificates.save($scope.certificate)
           .then(function(certificate){
               unsavedChanges.saved();
               $state.go('^.details', {id: certificate.Id});
           }));
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/certificates/new/certificate_new_controller.js
// module id = 8897550390905619
// module chunks = 1